import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import SwapEffectForm from './SwapEffectForm';
// import { initialValues  } from './initialValues-testing';
import { showSwapEffectApi, updateSwapEffectApi, clearEditedSwapEffect } from './swapEffectSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function SwapEffectUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.swapEffect);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateSwapEffectApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showSwapEffectApi({ navigate, id }));

        return () => dispatch(clearEditedSwapEffect());
    }, []);

    return (
        <SwapEffectForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default SwapEffectUpdate;
